import { brand } from '@/brand';
import cn from 'classnames';
import { useMenuItems } from '../model/useMenuItems';
import { MenuItem } from './MenuItem';

// Состав навигации задаёт бренд (src/brand/*), ссылки и подписи по умолчанию
// приходят из реестра экранов (src/app/navigation/screens.ts). Раньше здесь
// лежал литерал MENU_ITEMS — четвёртая копия карты путей после router.tsx,
// usePageTitle и самих страниц.

// disableCollapse: MobileSidebar рендерит тот же MenuList, но redux-стейт
// isSidebarCollapsed относится только к десктопному Sidebar. Без этого флага
// свёрнутый на десктопе навбар «протекал» в мобильную шторку (планшет /
// ресайз окна): подписи opacity-0, аккордеоны заперты, клики уходили в
// popup-оверлей.
export const MenuList = ({
  className,
  disableCollapse = false,
}: {
  className?: string;
  disableCollapse?: boolean;
}) => {
  const items = useMenuItems();

  return (
    <nav className={className}>
      {/* Пилюли стоят вплотную (4px, как в макете telecom): у них своя заливка
          и внутренний отступ, воздух между строками даёт он. */}
      <ul
        className={cn(
          'flex select-none flex-col text-center',
          brand.layout.sidebarMenu === 'pills' ? 'gap-1' : 'gap-[4px] lg:gap-[12px]',
        )}
      >
        {items.map((item, index) => (
          <MenuItem key={index} item={item} index={index} disableCollapse={disableCollapse} />
        ))}
      </ul>
    </nav>
  );
};
